const ErrorPage = () => {
    return (
        <div>
            <h2>404: Error! Page Not Found</h2>
        </div>
    );
};

export default ErrorPage;